import { useEffect } from "react";

// Capture phase so it also catches scrolling on nested containers. Overlays
// (antd dropdowns, popovers) stay pinned to a trigger that scrolls away, so
// close them on any scroll outside the kept region (their own scrollable body).
const useCloseOnOutsideScroll = (
  active: boolean,
  onClose: () => void,
  isInside: (target: EventTarget | null) => boolean
) => {
  useEffect(() => {
    if (!active) {
      return;
    }
    const handleScroll = (event: Event) => {
      if (!isInside(event.target)) {
        onClose();
      }
    };
    document.addEventListener("scroll", handleScroll, true);
    return () => document.removeEventListener("scroll", handleScroll, true);
  }, [active, isInside, onClose]);
};

export default useCloseOnOutsideScroll;
